const formButton = require('../blockDefinition/blockGroups/formButtons/types/FormButton');
const toggle = require('../blockDefinition/blockGroups/actionElements/types/Toggle');
const validationReporter = require('../helpers/validationReporter');
const { configureWorkspace } = require('../blockDefinition/blocklyWorkspace');
module.exports = async function metadataFromWorkspace(blocklyJson, subSet, namespaces, notificationHandler) {
    validationReporter.setValidationReporter(notificationHandler);
    // // JIT loading to delay using blockly until needed
    const Blockly = require('blockly');
    let headlessWorkspace;
    try {
        configureWorkspace(subSet, namespaces);
        // The MCP compiles in Node: renderer/toolbox options require a browser DOM.
        // Blockly loading can mutate JSON, so keep the caller's authoring source intact.
        headlessWorkspace = new Blockly.Workspace();
        Blockly.serialization.workspaces.load(JSON.parse(JSON.stringify(blocklyJson)), headlessWorkspace);

        formButton.validateWorkspace(headlessWorkspace);
        toggle.syncWorkspace(headlessWorkspace);
        const metadata = Blockly.JavaScript.workspaceToCode(headlessWorkspace);
        return { status: 'success', result: JSON.parse(metadata) };
    } catch (err) {
        notificationHandler(err);
        const { stack, message } = err;
        return { status: 'fail', result: { stack, message } };
    } finally {
        headlessWorkspace?.dispose();
        validationReporter.revertReporterToDefault();
    }
};
